import React from 'react'
import { Link } from 'gatsby'
import { Container, Grid, Button } from '@material-ui/core'

import Promise from '../components/images/banners/pros-promise-banner'
import ButtonCTA from '../components/buttonCTA'

export default function Display(props) {

    return (
        <>
            <Container className="flex justify-between items-center py-20 display-view">
                <Grid items container className="flex-col-reverse md:flex-row">
                    <Grid item md={6} sm={12} className="flex items-center mb-10">
                        <div className="text-center md:text-left display-text">
                            <h3>{props.title}</h3>
                            <p className="mb-10">{props.description}</p>
                            { props.descriptionTwo ? <p className="mb-10">{props.descriptionTwo}</p> : null }
                            <div className="buttons-container">
                                <Link to={props.prev}><Button variant="outlined" color="secondary" className="mr-5">previous</Button></Link>
                                <Link to={props.next}><Button variant="outlined" color="primary">next</Button></Link>
                            </div>
                        </div>
                    </Grid>
                    <Grid item md={6} sm={12} className="flex justify-center mb-20 md:m-0 display-image">
                        {props.image}
                    </Grid>
                </Grid>
            </Container>
            <Promise>
                <h3>The Pros Promise</h3>
                <h6>With a strong commitment to community, Chris Kontos and his team have the expertise and services to assist you with any of your print, design or digital needs, all at competitive prices.</h6>
            </Promise>

            <ButtonCTA />

        </>
    )
}
